module.exports = __webpack_public_path__ + "static/media/actions.b165f3e1.svg";